import toast from 'react-hot-toast';
import { AlertCircle } from 'lucide-react';

const Toast = {
  plain: (text: string) => {
    toast(text);
  },
  success: (text: string) => {
    toast.success(text);
  },
  error: (text: string) => {
    toast.error(text);
  },
  info: (text: string) => {
    toast(text, {
      icon: (
        <AlertCircle
          className='h-5 w-5 text-blue-500'
        />
      ),
    });
  },
};

export default Toast;